module.exports = __webpack_public_path__ + "static/img/xiaotongtie.7fcd7b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/medicines/xiaotongtie.jpg
// module id = UaHH
// module chunks = 1